module.exports = __webpack_public_path__ + "media/images/360/gym-30d968393a655ed2fa5866753eadf02d.jpg";